<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="ZM ALLOCATION">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'roleConfiguration' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back</v-btn
            >
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
        </v-card-text>
        <v-divider class="my-0" />

        <v-data-table
          :headers="headers"
          :items="zmList"
          disable-pagination
          :hide-default-footer="true"
        >
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{ name: 'updateZM', params: { zmMappingID: item.id } }"
            >
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                <v-icon small> mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center"
              >No Data Available</v-card-subtitle
            >
          </template>
        </v-data-table>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'

export default {
  name: 'ListZMAllocation',
  components: {
    MaterialCard
  },
  data () {
    return {
      search: '',
      zmList: [],
      data: [],
      isLoading: false,
      ams_zonalManagers: {
        id: ''
      },
      id: '',
      headers: [
        { text: 'Sr.No', value: 'id', sortable: true },
        { text: 'Zone', value: 'name', sortable: true },
        { text: 'Zonal Manager', value: 'zmName', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      models: [],
      loadingComponent: null
    }
  },
  created () {
    this.getZMList()
  },
  methods: {
    addZM: async function () {
      this.$router.push({ name: 'addZM' })
    },

    getZMList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${constants.API_URL}/api/get-zm-listing`
        )
        this.zmList = response.data
        this.zmList = this.zmList.map((item, index) => {
          item.zmName = `${
            item.ams_zonalManagers.length
              ? item.ams_zonalManagers[0].user.firstName
              : '-'
          } ${
            item.ams_zonalManagers.length
              ? item.ams_zonalManagers[0].user.lastName
              : ''
          }`

          return item
        })
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching ZM list : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
